<template>
  <div>
    <b-table
      responsive
      hover
      :items="this.desserts"
      :fields="this.header"
      borderless
      search
    >
      <template #cell(workorder_id)="item">
        <a href="#/Parts" @click="ProveRequsetpPart(item)"
          >#WO-{{ item.value }}</a
        >
      </template>
    </b-table>
    <b-modal id="proverequest" size="lg" centered scrollable>
      <template #modal-title>
        <h3 style="color: #32c040">Work Order Details</h3>
      </template>
      <template>
        <div
          style="
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
            box-shadow: 1px 1px 10px #888888;
          "
        >
          <div class="card-header text-white" style="background-color: #32c040">
            <vs-row>
              <vs-icon icon="inventory_2" size="35px" class="mr-3"></vs-icon>
              <div>
                <div style="height: 15px">
                  <p style="font-size: 90%">Parts</p>
                </div>
                <div>
                  <a style="font-size: 120%"
                    ><b style="color: #3932c0">{{ TotalPart }}</b> Total Parts
                    Costing ฿ <b style="color: #3932c0">{{ TOtalCost }}</b></a
                  >
                </div>
              </div>
            </vs-row>
          </div>
          <div class="card-body">
            <!-- {{WOPartDetails.order_items}} -->
            <b-table :items="WOPartDetails.order_items"></b-table>
          </div>
          <!-- <div
            v-for="(part, index) in WOPartDetails.order_items"
            :key="index"
            class="card-body"
          >
            <vs-row>
              {{ part.item_id }} 
            </vs-row>
          </div> -->
        </div>
        <br />
        <vs-card style="width: 100%; border-radius: 15px">
          <vs-collapse>
            <vs-collapse-item>
              <div slot="header">Details</div>
              <WorkTemplate
                :viewwork="WODetails"
                :dataPrint="dataPrint"
                :updateData="updateData"
                :workerlist="workerlist"
              />
            </vs-collapse-item>
          </vs-collapse>
        </vs-card>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-spacer />
          <vs-button
            id="btncancel"
            class="mr-2"
            color="grey"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('proverequest')"
          >
            Close
          </vs-button>
          <vs-button
            v-if="WOPartDetails.status == 'Requested'"
            color="red"
            type="filled"
            id="btncancel"
            style="border-radius: 20px; width: 10%"
            v-b-modal.rejectcomment
          >
            Reject
          </vs-button>
          <vs-button
            v-if="WOPartDetails.status == 'Requested'"
            type="filled"
            variant="danger"
            style="border-radius: 20px; width: 10%"
            class="ml-2"
            @click="ApproveWORequest"
            >Approve</vs-button
          >
        </vs-row>
      </template>
    </b-modal>
    <b-modal id="rejectcomment" size="lg" centered>
      <template #modal-title>
        <h3 style="color: #32c040">Reject</h3>
      </template>
      <b-form-textarea
        id="textarea"
        v-model="textReject"
        placeholder="Enter something..."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
      <template #modal-footer>
        <vs-row>
          <vs-spacer />
          <vs-button
            id="btncancel"
            class="mr-2"
            color="grey"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('rejectcomment')"
          >
            Close
          </vs-button>
          <vs-button
            v-if="WOPartDetails.status == 'Requested'"
            color="red"
            type="filled"
            id="btncancel"
            style="border-radius: 20px; width: 10%"
            @click="RejectWORequest"
          >
            Reject
          </vs-button>
        </vs-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import WorkTemplate from "../../Page/WorkTemplate.vue";
export default {
  data: () => ({
    WODetails: [],
    textReject: "",
    WOPartDetails: [],
    TotalPart: 0,
    TOtalCost: 0,
  }),
  props: {
    header: Array,
    desserts: Array,
  },
  components: {
    WorkTemplate,
  },
  methods: {
    ProveRequsetpPart(data) {
      // console.log(data.item.workorder_id, "po");
      this.$API.get(`work/${data.item.workorder_id}`).then((res) => {
        // console.log(res.data[0], "WOdetail");
        this.WODetails = res.data[0];
      });
      this.WOPartDetails = data.item;
      // console.log(this.WOPartDetails, "WOPartDetails");
      this.$bvModal.show("proverequest");
      this.sumPartANDCost(this.WOPartDetails);
    },
    sumPartANDCost(data) {
      this.TotalPart = 0;
      this.TOtalCost = 0;
      const dataPart = data.order_items;
      // console.log(dataPart, "LogPArt");
      dataPart.forEach((element) => {
        this.TotalPart += parseInt(element.quantity);
        this.TOtalCost += parseInt(element.paid_price);
      });
    },
    RejectWORequest() {
      const data = this.WOPartDetails;
      const data1 = this.WODetails;
      let data2 = {
        order_id: parseInt(data.order_id),
        order_items: data.order_items,
        total_parts_cost: data.total_parts_cost,
        currency: data.currency,
        timestamp: data.timestamp,
        status: data.status,
        workorder_id: parseInt(data.workorder_id),
        requester_id: parseInt(data.reqeuster_id),
        approver_id: parseInt(data.approver_id),
        location_id: parseInt(data1.location_id),
        comment: this.textReject,
      };
      console.log(this.WODetails);
      console.log(this.WOPartDetails);
      console.log(data2);
      this.$API
        .put(`parts/request/${data.order_id}/reject`, data2)
        .then((res) => {
          console.log(res, "pp");
        });
      setTimeout(() => {
        location.reload();
      }, 500);
    },
    ApproveWORequest() {
      const data = this.WOPartDetails;
      const data1 = this.WODetails;
      let data2 = {
        order_id: parseInt(data.order_id),
        order_items: data.order_items,
        total_parts_cost: data.total_parts_cost,
        currency: data.currency,
        timestamp: data.timestamp,
        status: data.status,
        workorder_id: parseInt(data.workorder_id),
        requester_id: parseInt(data.reqeuster_id),
        approver_id: parseInt(data.approver_id),
        location_id: parseInt(data1.location_id),
      };
      console.log(this.WODetails);
      console.log(this.WOPartDetails);
      console.log(data2);
      this.$API
        .put(`parts/request/${data.order_id}/approve`, data2)
        .then((res) => {
          console.log(res);
        });
      setTimeout(() => {
        location.reload();
      }, 500);
    },
  },
};
</script>

<style>
.cardM {
  margin-top: 5%;
  margin-bottom: 5%;
  width: 100%;
}
</style>